import { useState } from "react";
import { post } from "../api/client";
import type { Roster } from "../api/types";
import { identityLine, type ResolvedRoster } from "../lib/roster";
import { ErrorLine } from "./ui";

/**
 * The roster's state in one line (finding, not found, why not), with "Find
 * players" / "Try again" when the API offers it (`identity.can_request`: Basic
 * and Pro, and only when nothing is running or found for this video's run).
 */
export function PlayersStatus({ videoId, roster, selectable, onChange, className }: { videoId: string; roster: ResolvedRoster; selectable: boolean; onChange: () => Promise<void>; className?: string }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<Error | null>(null);
  const line = identityLine(roster, selectable);
  const can = roster.identity?.can_request === true;
  if (!line && !can && !err) return null;
  const ask = async () => {
    setBusy(true);
    setErr(null);
    try {
      await post<Roster>(`/v1/videos/${videoId}/players/identify`);
      await onChange();
    } catch (e) {
      setErr(e as Error);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className={className} data-testid="players-status" data-state={roster.identity?.state ?? "loading"}>
      {line && <p className="tiny">{line}</p>}
      {can && (
        <button className="u tiny" onClick={ask} disabled={busy} data-testid="find-players">
          {busy ? "Asking…" : roster.identity?.state === "failed" ? "Try again" : "Find players"}
        </button>
      )}
      <ErrorLine error={err} />
    </div>
  );
}
